import React from "react";

class ButtonChuyenForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text1: "",
    };
  }

  render() {
    let {
      showDongLai,
      quyenDongLai,
      showTatToan,
      quyenTatToan,
      showGiaHaKy,
      quyenGiaHan,
      showTraBotGoc,
      quyenTraBotGoc,
      showVayThem,
      quyenVayThem,
      IsDuNoGiamDan,
      IsKieuTraGocLai
    } = this.props;
    return (
      <div class="btn-group btn-light-new">
        <ul>
          {quyenDongLai && showDongLai && (
            <li>
              <a href={() => false} class="icon-bgnew" onClick={showDongLai}>
                <img src="/app-assets/images/icon-donglai-white.png" alt="" />
                Đóng lãi
              </a>
            </li>
          )}
          {quyenTatToan && showTatToan && (
            <li>
              <a href={() => false} class="icon-bgnew" onClick={showTatToan}>
                <img src="/app-assets/images/icon-tattoan-white.png" alt="" />
                Tất toán
              </a>
            </li>
          )}
          {quyenGiaHan && showGiaHaKy && (IsDuNoGiamDan == false || IsDuNoGiamDan == undefined) && (IsKieuTraGocLai == false || IsKieuTraGocLai == undefined) && (
            <li>
              <a href={() => false} class="icon-bgnew" onClick={showGiaHaKy}>
                <i class="mdi mdi-table-plus"></i>Gia hạn kỳ
              </a>
            </li>
          )}
          {quyenTraBotGoc && showTraBotGoc && (IsDuNoGiamDan == false || IsDuNoGiamDan == undefined) && (IsKieuTraGocLai == false || IsKieuTraGocLai == undefined)  && (
            <li>
              <a href={() => false} class="icon-bgnew" onClick={showTraBotGoc}>
                <i class="mdi mdi-bank-minus"></i>Trả bớt gốc
              </a>
            </li>
          )}
          {quyenVayThem && showVayThem && (IsDuNoGiamDan == false || IsDuNoGiamDan == undefined) && (IsKieuTraGocLai == false || IsKieuTraGocLai == undefined)  && (
            <li>
              <a href={() => false} class="icon-bgnew" onClick={showVayThem}>
                <i class="mdi mdi-bank-plus"></i>Vay thêm
              </a>
            </li>
          )}
          </ul>
      </div>
    );
  }
}
export default ButtonChuyenForm;
